import React from 'react';

export function Input({
  label,
  error,
  hint,
  type = 'text',
  className = '',
  required = false,
  ...props
}) {
  return (
    <div className={['flex flex-col gap-1', className].join(' ')}>
      {label && (
        <label className="text-sm font-medium text-gray-700">
          {label}
          {required && <span className="text-danger ml-1">*</span>}
        </label>
      )}
      <input
        type={type}
        className={[
          'w-full px-3 py-2 rounded-md border text-sm transition-colors',
          'focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-0',
          error
            ? 'border-danger focus:ring-danger'
            : 'border-gray-300 hover:border-gray-400',
        ].join(' ')}
        {...props}
      />
      {error && <p className="text-xs text-danger">{error}</p>}
      {hint && !error && <p className="text-xs text-gray-500">{hint}</p>}
    </div>
  );
}

export function Select({ label, error, children, className = '', required = false, ...props }) {
  return (
    <div className={['flex flex-col gap-1', className].join(' ')}>
      {label && (
        <label className="text-sm font-medium text-gray-700">
          {label}
          {required && <span className="text-danger ml-1">*</span>}
        </label>
      )}
      <select
        className={[
          'w-full px-3 py-2 rounded-md border text-sm bg-white transition-colors',
          'focus:outline-none focus:ring-2 focus:ring-primary',
          error ? 'border-danger' : 'border-gray-300 hover:border-gray-400',
        ].join(' ')}
        {...props}
      >
        {children}
      </select>
      {error && <p className="text-xs text-danger">{error}</p>}
    </div>
  );
}

export default Input;
